import { render, staticRenderFns } from "./MaterialSelectCustomValue.vue?vue&type=template&id=f3e628b6&"
import script from "./MaterialSelectCustomValue.vue?vue&type=script&lang=js&"
export * from "./MaterialSelectCustomValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports